import script from "./SogIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogIcon.vue?vue&type=script&setup=true&lang=ts"

import "./SogIcon.vue?vue&type=style&index=0&id=0989dc67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0989dc67"]])

export default __exports__